var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"content",staticClass:"content"},_vm._l((_vm.sectionKeys),function(key){return _c('Section',{key:key,ref:"section",refInFor:true,attrs:{"current":key === _vm.sectionKey,"sectionKey":key}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }